import { Box, Button, Typography } from "@mui/material";
import CriSection from "../../components/CriSection";
import Photo from "../../assets/images/flora_of_the_chigao_region_cover.png";
import { useState } from "react";
import PdfDialog from "../../components/PdfDialog";
import GeneraPDF from "../../assets/files/completed_research/key_to_genera.pdf";

const Genera = () => {
  const [showPdfDialog, setShowPdfDialog] = useState(false);

  const onShowResearchPaper = () => {
    setShowPdfDialog(true);
  };

  return (
    <CriSection>
      <Box
        sx={{
          display: "flex",
          flexDirection: {
            xs: "column",
            md: "row",
          },
        }}
      >
        <Box
          sx={{
            flexGrow: 1,
            flexBasis: 0,
          }}
        >
          <Typography
            sx={{
              fontSize: {
                xs: "24px",
                md: "36px",
              },
              fontWeight: 300,
              lineHeight: 1,
            }}
          >
            Keys to the Genera
          </Typography>

          <Typography
            sx={{
              fontSize: "16px",
              fontWeight: 300,
              lineHeight: 1.2,
              marginTop: "12px",
            }}
          >
            Keys to the Genera in the Flora of the Chicago Region by Wilhelm and
            Rericha.
          </Typography>

          <Button
            variant="contained"
            sx={{
              marginTop: "24px",
              padding: "8px 36px",
            }}
            onClick={onShowResearchPaper}
          >
            View Keys
          </Button>
        </Box>

        <Box
          sx={{
            marginRight: "36px",
            width: "400px",
          }}
        >
          <img
            src={Photo}
            alt="Poster"
            style={{
              width: "100%",
              height: "300px",
              borderRadius: "12px",
              objectFit: "contain",
            }}
          />
        </Box>
      </Box>

      <PdfDialog
        open={showPdfDialog}
        onClose={() => setShowPdfDialog(false)}
        title="Geneara Keys"
        pdfUrl={GeneraPDF}
      />
    </CriSection>
  );
};

export default Genera;
